const axios = require("axios");
import Modal from "../classes/modal";
import Swal from "sweetalert2/dist/sweetalert2.js";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

export default function InitProtocolGenerator() {
	const buttonGenerate = document.getElementById("button-generate-test-protocol");
	if (!buttonGenerate) return;

	buttonGenerate.addEventListener("click", () => {
		new Modal({
			showLoading: true,
			allowOutsideClick: false,
		}).show();

		generateProtocol();
	});
}

const successHandler = (reportUrl) => {
	Swal.fire({
		icon: "success",
		title: "Test Protokoll erfolgreich generiert 🎉",
		confirmButtonText: "Nice!",
		html: `
			<a href="${reportUrl}" target="_blank">Klicke hier um zum erstellten Testprotokoll zu gelangen! 😊</a>
			`,
	});
};

const errorHandler = (error) => {
	if (error.response && typeof error.response.data !== "undefined") {
		new Modal({
			icon: "error",
			html: `
				<p><strong>Leider ist bei der Erstellung des Protokolls ein Fehler aufgetreten.
				Wende dich bitte an einen Entwickler und gib die unten stehenden Informationen weiter.</strong></p>
				<p>${error.response.data.error}</p>
				<p>Passiert um: ${error.response.data.happened_at}</p>
				`
		}).show();
	}
	else {
		new Modal({
			icon: "error",
			html: `
				<p><strong>Leider ist bei der Erstellung des Protokolls ein Fehler aufgetreten.
				Wende dich bitte an einen Entwickler.</strong></p>
				`
		}).show();
	}
};

function generateProtocol() {
	// Get all the selected tags, which are the pressed button with the filterName "tests" in their dataset
	const tags = Array.from(document.querySelectorAll("button[data-filter-name=tests][aria-pressed=true]")).map((e) => e.dataset.filterType);
	const subject = document.getElementById("test-protocol-name").value;
	const folderId = document.getElementById("test-protocol-folder").value;
	const assigneeId = document.getElementById("test-protocol-assignee").value;

	axios({
		method: "POST",
		url: "/testprotocol/create",
		data: {
			subject: subject,
			folderId: folderId,
			tags: tags,
			assigneeId: assigneeId,
		},
	})
	.then(async function(response) {
		const reportUrl = response.data.listUrl;
		
		let finished = false;
		let nextValues = response.data.next;

		while (!finished) {
			const res = await axios({
				method: "POST",
				url: "/testprotocol/next",
				data: {...nextValues},
			});

			if (res.status === 200) {
				nextValues = res.data.next;
				finished = res.data.finished;
			}
		}

		successHandler(reportUrl);
	})
	.catch((error) => errorHandler(error));
}

